import { useState } from 'react';

import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslate } from 'react-admin';

import { flowchartLogger } from 'src/lib/logger';

import NodeControlForm from '../NodeControlForm';

import type { NodeControlsProps } from '../../dataProvider/types';

export interface DisconnectType extends Record<string, unknown> {
  reason: 'normal' | 'not_found';
}

interface DisconnectControlsProps extends NodeControlsProps {
  updateNodeData: (data: Record<string, unknown>) => void;
  data: DisconnectType;
}

export default function DisconnectControls({ updateNodeData, data }: DisconnectControlsProps): React.ReactElement {
  const [reason, setReason] = useState<DisconnectType['reason']>(data.reason ?? 'normal');
  const translate = useTranslate();

  const onDisconnectDataUpdate = (event: React.MouseEvent | React.FormEvent): void => {
    event.preventDefault();
    flowchartLogger.debug('DisconnectControls: onDisconnectDataUpdate', { reason });
    if (reason === null) {
      flowchartLogger.debug('DisconnectControls: reason is null. Update cancelled.');
      return;
    }
    updateNodeData({ reason });
  };
  return (
    <NodeControlForm onSubmit={onDisconnectDataUpdate} data={data} updateNodeData={updateNodeData}>
      <FormControl sx={{ display: 'flex', flexDirection: 'column' }} variant='outlined'>
        <InputLabel id='disconnect-controls-reason-label'>{translate('callflows.nodes.disconnect.reason')}</InputLabel>
        <Select
          labelId='disconnect-controls-reason-label'
          value={reason}
          label={translate('callflows.nodes.disconnect.reason')}
          onChange={(event) => {
            setReason(event.target.value);
          }}
          sx={{ mb: 1 }}
        >
          <MenuItem value='normal'>{translate('callflows.nodes.disconnect.reasonNormal')}</MenuItem>
          <MenuItem value='not_found'>{translate('callflows.nodes.disconnect.reasonNotFound')}</MenuItem>
        </Select>
      </FormControl>
    </NodeControlForm>
  );
}
